import { ReactNode } from 'react';
import { DialogClose, DialogHeader, DialogTitle, Skeleton } from '@sib/ui';
import { X } from '@sib/ui/icons';

interface DetailsModalHeaderProps {
  title: ReactNode;
  isTitleLoading?: boolean;
  onClose: () => void;
}

export const DetailsModalHeader = ({
  title,
  isTitleLoading = false,
  onClose,
}: DetailsModalHeaderProps) => (
  <DialogHeader className="text-primary flex w-full shrink-0 flex-row justify-between">
    <DialogTitle className="text-primary text-xl font-semibold">
      {isTitleLoading ? <Skeleton className="h-7 w-32" /> : title}
    </DialogTitle>
    <DialogClose onClick={onClose}>
      <X className="text-primary cursor-pointer" />
    </DialogClose>
  </DialogHeader>
);
